<template>
  <div class="welcome-page py-4">
    <div class="container">
      <div class="welcome-header text-center mb-4">
        <h1 class="h2 fw-bold text-primary">
          👋 Hola, {{ user?.nombres || "Usuario" }}!
        </h1>
        <p class="text-muted">
          Administra tu aula virtual de forma eficiente y moderna.
        </p>
      </div>

      <div class="guide-section mb-4">
        <h2 class="h4 mb-3 text-primary">📖 Guía Rápida</h2>
        <div class="row row-cols-1 row-cols-md-3 g-3">
          <div class="col">
            <div class="card h-100 shadow-sm">
              <div class="card-body d-flex align-items-center p-3">
                <i class="guide-icon fas fa-folder me-2 text-primary"></i>
                <div>
                  <h6 class="card-title mb-0"><strong>Categorías</strong></h6>
                  <p class="card-text small text-muted">Organiza tus cursos</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100 shadow-sm">
              <div class="card-body d-flex align-items-center p-3">
                <i class="guide-icon fas fa-users me-2 text-primary"></i>
                <div>
                  <h6 class="card-title mb-0"><strong>Usuarios</strong></h6>
                  <p class="card-text small text-muted">Gestiona roles</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100 shadow-sm">
              <div class="card-body d-flex align-items-center p-3">
                <i class="guide-icon fas fa-book me-2 text-primary"></i>
                <div>
                  <h6 class="card-title mb-0"><strong>Cursos</strong></h6>
                  <p class="card-text small text-muted">Crea y edita</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100 shadow-sm">
              <div class="card-body d-flex align-items-center p-3">
                <i class="guide-icon fas fa-certificate me-2 text-primary"></i>
                <div>
                  <h6 class="card-title mb-0"><strong>Certificados</strong></h6>
                  <p class="card-text small text-muted">Diseña y entrega</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100 shadow-sm">
              <div class="card-body d-flex align-items-center p-3">
                <i class="guide-icon fas fa-tasks me-2 text-primary"></i>
                <div>
                  <h6 class="card-title mb-0"><strong>Evaluaciones</strong></h6>
                  <p class="card-text small text-muted">Administra pruebas</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100 shadow-sm">
              <div class="card-body d-flex align-items-center p-3">
                <i class="guide-icon fas fa-user-tie me-2 text-primary"></i>
                <div>
                  <h6 class="card-title mb-0"><strong>Clientes</strong></h6>
                  <p class="card-text small text-muted">Gestiona info</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")) || {},
    };
  },
  methods: {
    startTour() {
    },
  },
};
</script>

<style scoped>
.welcome-page {
  background-color: #f8f9fa;
  min-height: 100vh;
}

.card {
  transition: transform 0.2s;
}

.card:hover {
  transform: translateY(-3px);
}

.guide-icon {
  font-size: 1.25rem;
  color: #007bff;
}
</style>